import { mapState } from 'vuex'

export default {
  name: 'NotificationsSetupChoice',
  props: {
    notif: {
      type: Object,
      required: true
    },
    value: {
      type: Array,
      required: true
    },
    showEmail: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      index: this.value.findIndex(v => v.type === this.notif.type)
    }
  },
  methods: {
    updateNotificationSetup(value, mode) {
      if (mode === 'web') {
        if (this.notif.type === 'joinRequestAccepted') {
          this.$store.dispatch('updateNotificationSetup', {
            type: 'joinRequestAccepted',
            web: value,
            email: this.value[this.index].email
          })
          this.$store.dispatch('updateNotificationSetup', {
            type: 'joinRequestRefused',
            web: value,
            email: this.value[this.index].email
          })
        } else {
          this.$store.dispatch('updateNotificationSetup', {
            type: this.notif.type,
            web: value,
            email: this.value[this.index].email
          })
        }
      } else if (mode === 'email') {
        if (this.notif.type === 'joinRequestAccepted') {
          this.$store.dispatch('updateNotificationSetup', {
            type: 'joinRequestAccepted',
            web: this.value[this.index].web,
            email: value
          })
          this.$store.dispatch('updateNotificationSetup', {
            type: 'joinRequestRefused',
            web: this.value[this.index].web,
            email: value
          })
        } else {
          this.$store.dispatch('updateNotificationSetup', {
            type: this.notif.type,
            web: this.value[this.index].web,
            email: value
          })
        }
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.user
    })
  }
}
